import { GraphQLCampaign } from 'modules/campaigns/lib/types';

export const getDeactivateCampaignPayload = (campaign: GraphQLCampaign) => {
  const { id: campaignId } = campaign;

  return {
    campaignId,
  };
};
